<div class="d-flex align-items-center list-row">
  <i class="bi bi-geo-alt me-2"></i>
  <div class="d-flex flex-column justify-content-center gap-1">
    <span class="region-list">{{ region }}</span>
    <span class="country-style">{{ country }}</span>
  </div>
</div>